import PropTypes from 'prop-types'

let markedPromise
let parse = null

function useMarkdownParse() {
  if (parse) return parse

  markedPromise = markedPromise ?? import('marked')

  throw markedPromise.then(marked => {
    parse = marked.parse
  })
}

const MarkdownContent = ({content}) => {
  const parseFn = useMarkdownParse()
  return <div dangerouslySetInnerHTML={{__html: parseFn(content)}} />
}

MarkdownContent.displayName = 'MarkdownContent'

MarkdownContent.propTypes = {
  content: PropTypes.string.isRequired
}

export default MarkdownContent
